import request from '../request';
import { url } from '../urlConfig';

const baseUrl = request.getBaseUrl();
const server = {
  // 审核历史
  queryApplyOperationLogs(params) {
    return request.post('/standard/evaluation/applyDetail/queryApplyOperationLogs', params);
  },

  // 表3-添加产品性能评价
  addProductPerformance(params) {
    return request.post('/standard/evaluation/stepAuxiliary/addProductPerformance', params);
  },
  // 表4-修改覆盖等级-选中复用的节点
  coverChild(params) {
    return request.post('/standard/evaluation/stepAuxiliary/coverChild', params);
  },
  // 表4-修改覆盖等级-下拉列表
  coverOption(params) {
    return request.post('/standard/evaluation/stepAuxiliary/coverOption', params);
  },

  // 表3-删除产品单元分项
  deleteProduct(params) {
    return request.post('/standard/evaluation/stepAuxiliary/deleteProduct', params);
  },

  // 表4-删除本项
  deleteProductPerformance(params) {
    return request.post('/standard/evaluation/stepAuxiliary/deleteProductPerformance', params);
  },

  // 表3模板下载
  unitDivisionDown(params) {
    return request.fetch('/standard/evaluation/file/unitDivisionDown', params, {
      responseType: 'blob',
    });
  },
  // 表3模板导入
  productUnitPartationImport() {
    return `${url.base}/standard/evaluation/file/productUnitPartationImport`;
  },

  // 表4.5：产品性能评价下载
  performanceEvaluationDown(params) {
    return request.fetch('/standard/evaluation/file/performanceEvaluationDown', params, {
      responseType: 'blob',
    });
  },
  // 表4-5检测内容和依据导入
  productPerformanceImport() {
    return `${url.base}/standard/evaluation/file/productPerformanceImport`;
  },

  enquiryFileUrl() {
    return `${url.base}/transaction-center/Enquiry/fileUpload`;
  },
  // 评价办法列表
  evaluationList(params) {
    return request.post('/standard/evaluation/institution/evaluationList', params);
  },
  // 分步辅助填写评价办法结构化内容补充
  tempSaveOrConfirmNext(params) {
    return request.post('/standard/evaluation/stepAuxiliary/tempSaveOrConfirmNext', params);
  },
  // 当前步已编辑内容详情
  stepDetail(params) {
    return request.post('/standard/evaluation/stepAuxiliary/stepDetail', params);
  },

  // 当前步已编辑内容详情
  auxiliaryStepDetail(params) {
    return request.post('/standard/evaluation/stepAuxiliary/stepDetail', params);
  },
  // 点击编辑的时候先调这个接口看看编辑到那步了  该到哪一步进行编辑,
  getStep(params) {
    return request.post('/standard/evaluation/stepAuxiliary/step', params);
  },

  structEvaluationDetail(params) {
    return request.post('/standard/evaluation/institution/structEvaluationDetail', params);
  },

  // 非结构化评价办法详情
  nonStructEvaluationDetail(params) {
    return request.post('/standard/evaluation/institution/nonStructEvaluationDetail', params);
  },
  // 咨询人列表
  consultList(params) {
    return request.post('/standard/evaluation/institution/consultList', params);
  },
  // 修改咨询人
  updateConsult(params) {
    return request.post('/standard/evaluation/institution/updateConsult', params);
  },

  // 评价机构申请确认 评价机构获取评价申请确认列表
  loadApplyInfos(params) {
    return request.post('/standard/evaluation/confirm/loadApplyInfos', params);
  },
  // 评价机构确认申请
  confirmEvaluattionApply(params) {
    return request.post('/standard/evaluation/confirm/confirmEvaluattionApply', params);
  },
  // 产品质量评价申请评价办法(含单元分项)列表-供应商
  queryEvaluationWithProductPageList(params) {
    return request.post('/standard/evaluation/evaluationApply/queryEvaluationWithProductPageList', params);
  },
  // 产品质量评价申请-预保存处理
  pretreatmentEvaluationApply(params) {
    return request.post('/standard/evaluation/evaluationApply/pretreatmentEvaluationApply', params);
  },
  // 产品质量评价申请前校验-供应商
  checkEvaluationApplyCondition(params) {
    return request.post('/standard/evaluation/evaluationApply/checkEvaluationApplyCondition', params);
  },
  // 产品质量评价申请-查看更多业务咨询人-供应商
  queryConsultList(params) {
    return request.post('/standard/evaluation/evaluationApply/queryConsultList', params);
  },
  // 第5步 附录文件
  uploadEvaluationAttachment() {
    return `${url.base}/standard/evaluation/file/uploadEvaluationAttachment`;
  },
  // 专业列表
  queryEvaluationSpecialtyList(params) {
    return request.post('/standard/evaluation/evaluationApply/queryEvaluationSpecialtyList', params);
  },
  // 产品类目
  queryWlLbDisTree(params) {
    return request.post('/product/wlLbDis/queryWlLbDisTree', params);
  },
  // 获取评价机构列表
  queryEvaluationAssessmentAgentList(params) {
    return request.post('/standard/evaluation/evaluationApply/queryEvaluationAssessmentAgentList', params);
  },
  // 产品质量评价申请-是否开通在线支付-供应商
  checkIsOpenOnlinePay(params) {
    return request.post('/standard/evaluation/evaluationApply/checkIsOpenOnlinePay', params);
  },
  // 查询供应商信息
  getEvaluationApplySupplierDetail(params) {
    return request.post('/standard/evaluation/evaluationApply/getEvaluationApplySupplierDetail', params);
  },
  // 资质信息，供应服务能力
  getEvaluationApplyStandardizedQualificationDetail(params) {
    return request.post(
      '/standard/evaluation/evaluationApply/getEvaluationApplyStandardizedQualificationDetail',
      params
    );
  },
  // 评价详情 里面的 查看
  getGSNAbsolutePathUrl(params) {
    return request.post('/standard/evaluation/evaluationApply/getGSNAbsolutePathUrl', params);
  },
  // 基本资质审查表导入
  basicQualificationImport() {
    return `${url.base}/standard/evaluation/file/basicQualificationImport`;
  },
  // 基本资质审查表下载
  basicQualificationsDown(params) {
    return request.fetch('/standard/evaluation/file/basicQualificationsDown', params, {
      responseType: 'blob',
    });
  },
  // 生产保障能力审查表下载
  produceAbilityDown(params) {
    return request.fetch('/standard/evaluation/file/produceAbilityDown', params, {
      responseType: 'blob',
    });
  },
  // 生产保障能力审查表导入
  produceAbilityImport() {
    return `${url.base}/standard/evaluation/file/produceAbilityImport`;
  },

  // 规范性引用下载
  normativeReferencesDown(params) {
    return request.fetch('/standard/evaluation/file/normativeReferencesDown', params, {
      responseType: 'blob',
    });
  },
  // 规范性引用导入
  normativeReferencesImport() {
    return `${url.base}/standard/evaluation/file/normativeReferencesImport`;
  },
  // 产品质量评价业务操作手册
  downloadEvaluationUserManual(params) {
    return request.fetch('/standard/evaluation/evaluationApply/downloadEvaluationUserManual', params, {
      responseType: 'blob',
    });
  },
  // 申请评价的 产品质量评价办法 点击
  getOssPath(params) {
    return request.post('/standard/evaluation/evaluationApply/getOssPath', params);
  },
  // 评价机构-评价资料复审列表
  queryApplyDataReviewPage(params) {
    return request.post('/standard/evaluation/applyDataReview/queryApplyDataReviewPage', params);
  },
  // 评价机构-申请单反馈数据查询
  queryApplyAgencyFeedbackList(params) {
    return request.post('/standard/evaluation/applyDataReview/queryApplyAgencyFeedbackList', params);
  },
  // 评价机构-申请单反馈数据提交
  addApplyAgencyFeedbackInfo(params) {
    return request.post('/standard/evaluation/applyDataReview/addApplyAgencyFeedbackInfo', params);
  },
  // 产品质量评价委托书详情
  queryApplyCommission(params) {
    return request.post('/standard/evaluation/applyNotice/queryApplyCommission', params);
  },
  // 评价机构-订单查询
  queryEvaluationAgencyApplyPageList(params) {
    return request.post('/standard/evaluation/evaluationAgency/queryEvaluationAgencyApplyPageList', params);
  },
  // 评价机构-订单查询-导出
  exportAgencyApplyOrder(params) {
    return request.post('/standard/evaluation/evaluationAgency/exportAgencyApplyOrder', params, {
      responseType: 'blob',
    });
  },
  // 产品质量评价-申请详情数据展示-GSN资质信息
  queryStandardizedQualificationInfo(params) {
    return request.post('/standard/evaluation/applyDetail/queryStandardizedQualificationInfo', params);
  },
  // 产品质量评价申请-申请单详情(（订单信息+发票+邮寄地址+业务咨询人）)-供应商
  getEvaluationApplyDetail(params) {
    return request.post('/standard/evaluation/applyDetail/getEvaluationApplyDetail', params);
  },
  // 产品质量评价-申请详情数据展示-评价信息
  queryEvaluationApplyItemInfo(params) {
    return request.post('/standard/evaluation/applyDetail/queryEvaluationApplyItemInfo', params);
  },
  // 产品质量评价-申请详情数据展示-公司三证信息
  queryCompanyThreeEvidenceInfo(params) {
    return request.post('/standard/evaluation/applyDetail/queryCompanyThreeEvidenceInfo', params);
  },
  // 评价机构资料复审-评价机构一键下载gsn资料
  downLoadGSNQualificationFiles(params) {
    return request.post('/standard/evaluation/applyDataReview/downLoadGSNQualificationFiles', params);
  },
  // 评价机构资料复审-评价机构审核
  auditEvaluationApplyDataReviewInfo(params) {
    return request.post('/standard/evaluation/applyDataReview/auditEvaluationApplyDataReviewInfo', params);
  },
  // 产品质量评价申请审核-领导审核(报告审核列表)
  queryEvaluationLeaderAuditPage(params) {
    return request.post('/standard/evaluation/leaderAudit/queryEvaluationLeaderAuditPage', params);
  },
  // 产品质量评价申请审核-领导审核详情
  leaderAuditDetail(params) {
    return request.post('/standard/evaluation/leaderAudit/auditDetail', params);
  },
  // 产品质量评价-申请详情数据展示-报告审核评价信息
  queryReportAuditEvaluationInfo(params) {
    return request.post('/standard/evaluation/applyDetail/queryReportAuditEvaluationInfo', params);
  },
  // 产品质量评价-申请详情数据展示-报告审核评价信息(多个评价信息)
  queryCoverEvaluationInfo(params) {
    return request.post('/standard/evaluation/applyDetail/queryCoverEvaluationInfo', params);
  },
  // 报告审核审核历史
  queryEvaluationAuditLogs(params) {
    return request.post('/standard/evaluation/applyDetail/queryEvaluationAuditLogs', params);
  },
  // 检查是否只能驳回到现场审查环节 1：限制；0：无限制
  checkAuditLimit(params) {
    return request.post('/standard/evaluation/leaderAudit/checkAuditLimit', params);
  },
  // 领导审核
  leaderAudit(params) {
    return request.post('/standard/evaluation/leaderAudit/audit', params);
  },
  // 评价报告信息
  queryEvaluationReport(params) {
    return request.post('/standard/evaluation/applyDetail/queryEvaluationReport', params);
  },
  // 产品质量评价-申请详情数据展示-报告下载
  downLoadEvaluationFile(params) {
    return request.post('/standard/evaluation/applyDetail/downLoadEvaluationFile', params, {
      responseType: 'blob',
    });
  },
  // 评价业务-评价业务管理列表-评价机构
  queryEvaluationApplyItemPageList(params) {
    return request.post('/standard/evaluation/evaluationApplyGrade/queryEvaluationApplyItemPageList', params);
  },
  // 评价业务-评价业务管理列表-订单等信息
  getEvaluationApplyGradeDetail(params) {
    return request.post('/standard/evaluation/evaluationApplyGrade/getEvaluationApplyDetail', params);
  },
  // 评价业务-现场审查录入页面-结构化
  structSiteReview(params) {
    return request.post('/standard/evaluation/evaluationApplyGrade/structSiteReview', params);
  },
  // 评价业务-提交现场审查录入-结构化
  submitStructSiteReview(params) {
    return request.post('/standard/evaluation/evaluationApplyGrade/submitStructSiteReview', params);
  },
  // 评价业务-评价业务管理列表-报告上传
  uploadReportAttachment(params) {
    return request.post('/standard/evaluation/evaluationApplyGrade/uploadReportAttachment', params);
  },
  // 现场审查录入-非结构化-评价机构
  addUnstructuredApplyGradeScene(params) {
    return request.post('/standard/evaluation/evaluationApplyGrade/addUnstructuredApplyGradeScene', params);
  },
  // 产品检测录入-非结构化-评价机构
  addUnstructuredApplyGradeTest(params) {
    return request.post('/standard/evaluation/evaluationApplyGrade/addUnstructuredApplyGradeTest', params);
  },
  // 评价业务-结构化实物测试（检测内容和产品性能测试）-评价机构
  getStructProductTestReviewVO(params) {
    return request.post('/standard/evaluation/evaluationApplyGrade/getStructProductTestReviewVO', params);
  },
  // 产品检测录入-结构化-评价机构
  addStructuredApplyProductTest(params) {
    return request.post('/standard/evaluation/evaluationApplyGrade/addStructuredApplyProductTest', params);
  },
  // 评价业务-反馈历史-评价机构
  queryFeedbackList(params) {
    return request.post('/standard/evaluation/evaluationApplyGrade/queryFeebackList', params);
  },
  // 评价业务-反馈-评价机构
  addFeedback(params) {
    return request.post('/standard/evaluation/evaluationApplyGrade/addFeeback', params);
  },
  // 产品质量评价通知列表
  applyNoticeQueryApplyNoticePage(params) {
    return request.post('/standard/evaluation/applyNotice/queryApplyNoticePage', params);
  },
  // 产品质量评价通知详情
  applyNoticeQueryApplyNotice(params) {
    return request.post('/standard/evaluation/applyNotice/queryApplyNotice', params);
  },
  // 获取预览信息接口
  getEvaluationPaymentOnlinePreview(params) {
    return request.post('/standard/evaluation/paymentOnline/getEvaluationPaymentOnlinePreview', params);
  },
  // 发送支付请求接口
  evaluatePaymentSend(params) {
    return request.post('/standard/evaluation/paymentOnline/evaluatePaymentSend', params);
  },
  // 流通商--评价办法pdf--根据evaluationId
  distributors(params) {
    return request.post('/standard/evaluation/pdf/distributors', params);
  },
  // 流通商--评价细则pdf--根据evaluationId
  distributorsDetail(params) {
    return request.post('/standard/evaluation/pdf/distributorsDetail', params);
  },

  // 生产商--评价办法pdf--根据evaluationId
  producer(params) {
    return request.post('/standard/evaluation/pdf/producer', params);
  },
  // 生产商--评价细则pdf--根据evaluationId
  producerDetail(params) {
    return request.post('/standard/evaluation/pdf/producerDetail', params);
  },
  // 下载现场审查报告(根据页面录入数据生成报告并下载)
  downloadSiteReviewReport(params) {
    return request.post('/standard/evaluation/pdfReport/downloadSiteReviewReport', params, { responseType: 'blob' });
  },
  // 下载实物测试报告(根据页面录入数据生成报告并下载)
  downloadProductTestReport(params) {
    return request.post('/standard/evaluation/pdfReport/downloadProductTestReport', params, { responseType: 'blob' });
  },

  fileUploadForProductEvaluationResult: `${baseUrl}/user-center/oss/fileUploadForProductEvaluationResult `,
  // 分页查询
  queryPageEvaluation(params) {
    return request.post('/user-center/productEvaluationResult/queryPage', params);
  },
  // 编辑
  modifyEvaluation(params) {
    return request.post('/user-center/productEvaluationResult/modify', params);
  },
  // 删除
  deleteEvaluation(params) {
    return request.post('/user-center/productEvaluationResult/delete', params);
  },
  // 新增
  addEvaluation(params) {
    return request.post('/user-center/productEvaluationResult/add', params);
  },
  // 查看详细
  queryByIdEvaluation(params) {
    return request.post('/user-center/productEvaluationResult/queryById', params);
  },
  // 批量删除
  batchDeleteEvaluation(params) {
    return request.post('/user-center/productEvaluationResult/batchDelete', params);
  },
};
export default server;
